module.exports = __webpack_public_path__ + "static/img/iturrizaga.9810b09.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/personas/iturrizaga.jpg
// module id = 478
// module chunks = 11